import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { Router } from '@angular/router';
import { WalPageService } from '../../../services/session/wal-page.service';
import { SharedService } from '../../../services/shared.service';
import { DataExchangeService } from '../../../services/session/data-exchange.service';
import { HeaderSectionDirective } from '../../../directives/header-section.directive';
import { FooterSectionDirective } from '../../../directives/footer-section.directive';
import { INotificationHistory } from '../../../interfaces/notification/notification-history';
import { INotificationHistoryResponse } from '../../../interfaces/notification/notification-history-response';
import { ISessionDetails } from '../../../interfaces/session-details';
import { IBrandInfo } from '../../../interfaces/brand/brand-info';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'app-notif-log-card-deck',
    standalone: true,
    imports: [],
    templateUrl: './notification-log-card-deck.component.html',
    styleUrl: './notification-log-card-deck.component.css'
})
export class NotificationLogCardDeckComponent  implements OnInit {

  @ViewChild(HeaderSectionDirective, {static: true}) headerComponentSection!: HeaderSectionDirective;
  @ViewChild(FooterSectionDirective, {static: true}) footerComponentSection!: FooterSectionDirective;

  notificationList!: INotificationHistory[];

    private readonly router = inject(Router);
    private readonly dataExchangeService = inject(DataExchangeService);
    private readonly walPageService = inject(WalPageService);
    private readonly sharedService = inject(SharedService);
    private readonly logger = inject(NGXLogger);

    clientTimezone!: string;

  constructor()
    {}

  ngOnInit() {
    // Get the parameters from the caller (Walletron)
    let region = this.dataExchangeService.getRegion();
    let session: ISessionDetails = this.dataExchangeService.getSession();
    let brandInfo: IBrandInfo = this.dataExchangeService.getBrandInfo();
    this.clientTimezone = this.sharedService.getBrandConfigProperty(brandInfo, 'CLIENT_TIMEZONE', 'America/New_York');

    if (region && session) {
      // Retrieve notification history
      this.getNotificationLog(region, session.walPageUuid);
    }
  }

  getNotificationLog(region: string, sessionId: string) {
    this.walPageService.getNotificationLog(region, sessionId)
    .subscribe({
      next: (response) => {
        if (response && response.notifList) {
          this.notificationList = response.notifList;
        }
      },
      error: (error) => {
        // this.logger.error('NotificationLogCardDeckComponent - getNotificationLog', error);
        this.dataExchangeService.setMessageText(error);
        this.router.navigate(['/err']);
      },
      complete: () => {
      }
    });
  }

  onClose() {
    window.open('','_parent','');
    window.close();
  }

  isValidTimestamp(dateString: string): boolean {
    const date = new Date(dateString);
    return !isNaN(date.getTime());
  }

  convertUTCToEDT(utcString: string): string {
    if (utcString.indexOf('Z') <= 0) utcString = utcString + 'Z';
    const utcDate = new Date(utcString);
    const options: Intl.DateTimeFormatOptions = {
      timeZone: this.clientTimezone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    };
    const formatter = new Intl.DateTimeFormat('en-US', options);
    const parts = formatter.formatToParts(utcDate);

    const year = parts.find(p => p.type === 'year')?.value;
    const month = parts.find(p => p.type === 'month')?.value.padStart(2, '0');
    const day = parts.find(p => p.type === 'day')?.value.padStart(2, '0');
    const hour = parts.find(p => p.type === 'hour')?.value.padStart(2, '0');
    const minute = parts.find(p => p.type === 'minute')?.value.padStart(2, '0');
    const second = parts.find(p => p.type === 'second')?.value.padStart(2, '0');

    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
  }

}


